// Amazon product-platform helpers shared by the campaigns table and edit modal.
import { isValidAmazonAsin } from "@stack/shared";

export const AMAZON_PLATFORM_NAME = "Amazon";
export const DEFAULT_AMAZON_LINK_PREFIX = "https://www.amazon.com/dp/";

// Returns the Amazon product URL for a valid ASIN on the Amazon platform, else null.
export const getAmazonAsinUrl = (platform, code) => {
  const trimmedCode = typeof code === "string" ? code.trim() : code;
  if (
    platform?.name !== AMAZON_PLATFORM_NAME ||
    !isValidAmazonAsin(trimmedCode)
  ) {
    return null;
  }
  const prefix = platform.linkPrefix || DEFAULT_AMAZON_LINK_PREFIX;
  return `${prefix}${trimmedCode}`;
};

// Builds a product link from the selected platform + code. An empty linkPrefix
// is ambiguous: the product-platforms fetch may still be in flight (platform
// unknown) or the platform may intentionally have no prefix (e.g. Brand
// website). Apply the Amazon ASIN fallback while the platform is still unknown
// (so a valid ASIN never renders as a bare code on first load) or when the
// platform is Amazon. Once the platform is known and is not Amazon, preserve the
// supplied code so a non-Amazon ASIN-shaped code never becomes a bogus Amazon link.
export const buildProductLink = (platform, code) => {
  const trimmedCode = typeof code === "string" ? code.trim() : "";
  if (platform?.linkPrefix) {
    return `${platform.linkPrefix}${trimmedCode}`;
  }
  const platformUnknown = !platform;
  if (
    (platformUnknown || platform.name === AMAZON_PLATFORM_NAME) &&
    isValidAmazonAsin(trimmedCode)
  ) {
    return `${DEFAULT_AMAZON_LINK_PREFIX}${trimmedCode}`;
  }
  return trimmedCode;
};
